// removed by extract-text-webpack-plugin
module.exports = {"homeBanner":"_2Pnn","logo":"QyME","resortHome":"_2l1F","fade":"_2Lnp","bg":"_1VQT","bgX":"_32ZN","moving":"RYuI","blurred":"_4gzY","mainMenuIcon":"_3ZfS","main_menu":"_2s50","main_menu_on":"_2Xm7","main_menu_off":"_1x5b","scrollArrow":"_3h9H","explore":"_1bvb","txt":"_2_4C","arrow":"j8qV","bounce":"_2eRH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/homebanner/style.css
// module id = 344
// module chunks = 9